import { useState, useCallback, useRef } from "react";
import { API } from '../../../api';

export default function CarrouselPreview({ slide, onDropImage, originalAvailable, showOriginal, onToggleOriginal }) {
	const [dragOver, setDragOver] = useState(false);
	const dragCounter = useRef(0);

	const handleDragOver = (e) => {
		if (!onDropImage) return;
		e.preventDefault();
		e.stopPropagation();
		setDragOver(true);
	};

	const handleDragEnter = (e) => {
		if (!onDropImage) return;
		e.preventDefault();
		e.stopPropagation();
		dragCounter.current += 1;
		setDragOver(true);
	};

	const handleDragLeave = (e) => {
		if (!onDropImage) return;
		e.preventDefault();
		e.stopPropagation();
		dragCounter.current = Math.max(0, dragCounter.current - 1);
		if (dragCounter.current === 0) setDragOver(false);
	};

	const handleDrop = useCallback((e) => {
		if (!onDropImage) return;
		e.preventDefault();
		e.stopPropagation();
		dragCounter.current = 0;
		setDragOver(false);
		const file = e.dataTransfer?.files?.[0];
		if (!file) return;
		const validTypes = ["image/png", "image/jpeg", "image/jpg", "image/gif", "image/webp", "image/avif"];
		if (!validTypes.includes(file.type)) return;

		// Laissez le gestionnaire parent créer l'Object URL et gérer le nettoyage
		onDropImage(file);
	}, [onDropImage]);
	if (!slide) {
		return (
			<div className="carrousel-preview empty">
				<p>Sélectionnez un slide pour voir l'aperçu</p>
			</div>
		);
	}

	const getImageSrc = () => {
		const typesource = (slide.typesource || slide.typesource || "").toLowerCase();
		const imgname = slide.imgname || slide.imgname || "";
		const ext = slide.extension || "";
		const hasLoadError = slide.urlLoadError === true;

		// Si URL web a échoué au chargement, ne pas retourner de src \\
		if (typesource === "web" && imgname && hasLoadError) return null;

		// Base64/Object URL preview (fichier local sélectionné) \\
		if (typesource === "preview" && imgname) return imgname;

		// URL web externe \\
		if (typesource === "web" && imgname && !hasLoadError) return imgname;

		// Fichier local stocké sur le serveur \\
		if (typesource === "local" && imgname && ext) return `${API.API_LINK}/file/pictures/carrousel/source/${imgname}.${ext}`;

		// Fallback: si pas de typesource mais qu'on a imgname et ext, on suppose local \\
		if (!typesource && imgname && ext) return `${API.API_LINK}/file/pictures/carrousel/source/${imgname}.${ext}`;

		return null;
	};

	const imageSrc = getImageSrc();
	const hasUrlError = slide.urlLoadError === true;
	const isWebType = (slide.typesource || "").toLowerCase() === "web";

	return (
		<div className={`carrousel-preview${onDropImage ? " drop-enabled" : ""}${dragOver ? " drag-over" : ""}`}
			 onDragOver={handleDragOver}
			 onDragEnter={handleDragEnter}
			 onDragLeave={handleDragLeave}
			 onDrop={handleDrop}>
			<div className="preview-label">Aperçu en temps réel</div>

			{/* modif pour utiliser l element générique de carrousel */}
			{/* <CarouselSlideContent slide={slide} /> */}
			<div className="preview-slide">
				{imageSrc && !hasUrlError ? (
                    <div className="container-image">
                        <picture>
							<img 
								src={imageSrc} 
								alt={`Admin Slide Preview ${(slide.imgtitre ?? slide.imgtitre) || "Titre du slide"}`}
								onError={(e) => { 
									console.error('Erreur chargement image:', imageSrc); 
									e.target.style.display = 'none';
								}}
							/>
                        </picture>
                    </div>
				) : (
					<div className="preview-placeholder">
						<span>📷</span>
						{hasUrlError && isWebType ? (
							<p style={{ color: '#e74c3c' }}>URL invalide</p>
						) : (
							<p>Aucune image sélectionnée</p>
						)}
					</div>
				)}
				<div className="Tranding-Slide-Content">
					<h1 className="Box-Header-Text">{slide.evenement && slide.evenement.toLowerCase() !== 'aucun' && slide.evenement.toLowerCase() !== 'aucune' ? slide.evenement : ''}</h1>
					<div className="Slide-Content-Bottom">
					<h2 className="Slider-Name">{(slide.imgtitre ?? slide.imgtitre) || ""}</h2>
					<h3 className="Slider-box-bottom">
						<span>{(slide.imgdescription ?? slide.imgdescription) || ""}</span>
						<div className="rating"><ion-icon name="rose"></ion-icon><ion-icon name="rose"></ion-icon><ion-icon name="rose"></ion-icon><ion-icon name="rose"></ion-icon><ion-icon name="rose"></ion-icon></div>
					</h3>
					</div>
				</div>
			</div>
			{/* */}
              

			{!slide.isvisible && (
				<div className="preview-warning">⚠️ Ce slide est actuellement masqué</div>
			)}

			{originalAvailable && (
				<div className="preview-tools">
					<label className="toggle-switch">
						<input type="checkbox" checked={!!showOriginal} onChange={onToggleOriginal} />
						<span className="toggle-slider"></span>
						<span className="toggle-label">Voir la version originale</span>
					</label>
				</div>
			)}
		</div>
	);
}
